import { useMutation, useQueryClient } from "@tanstack/react-query";
import { agencySaleDetail } from "../../services/agencies-sales-details";
import { useGetMyProfile } from "../profile/use-get-my-profile";
import { AGENCIES_SALES_DETAILS_QUERY_KEY } from "./use-get-agencies-sales-details";
import { AGENCIES_SALES_TOTAL_QUERY_KEY } from "./use-get-agencies-sales-total";

export const useCreateAgencySaleDetail = () => {
  const { invalidate } = useGetMyProfile();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: agencySaleDetail.create,
    onSettled: () => {
      invalidate();
      // após uma venda, atualiza o total (fechamento) e o histórico
      queryClient.invalidateQueries({
        queryKey: [AGENCIES_SALES_TOTAL_QUERY_KEY],
        exact: false,
      });
      queryClient.invalidateQueries({
        queryKey: [AGENCIES_SALES_DETAILS_QUERY_KEY],
        exact: false,
      });
    },
  });

  return {
    create: mutateAsync,
    isLoading,
  };
};
